import { render, staticRenderFns } from "./PublishPresentationInfo.vue?vue&type=template&id=6cce78ca&scoped=true&"
import script from "./PublishPresentationInfo.vue?vue&type=script&lang=js&"
export * from "./PublishPresentationInfo.vue?vue&type=script&lang=js&"
import style0 from "./PublishPresentationInfo.vue?vue&type=style&index=0&id=6cce78ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cce78ca",
  null
  
)

export default component.exports